export interface NewsItem {
  id: number;
  title: string;
  date: string;
  category: string;
  cover: string;
  summary: string;
  content: string[];
}

export const newsList: NewsItem[] = [
  {
    id: 1,
    title: "叶山小百合主演《雾港夜航》正式定档，首支预告公开",
    date: "2024-11-18",
    category: "定档",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20promotional%20image%20of%20a%20rainy%20harbor%20at%20night%20with%20cargo%20ships%20and%20fog%20under%20amber%20harbor%20lights%2C%20moody%20teal%20color%20grade%2C%20editorial%20cinematic%20photography%2C%20subtle%20film%20grain&width=800&height=500&seq=yh-news-01&orientation=landscape",
    summary: "犯罪悬疑电影《雾港夜航》公布上映日期，同步释出首支预告片，叶山小百合饰演的潜水调查员首次亮相。",
    content: [
      "由佐藤健一执导、叶山小百合领衔主演的犯罪悬疑电影《雾港夜航》今日正式宣布定档，影片将于明年春季与观众见面。片方同时发布了时长两分钟的首支预告，冷峻的港口夜色与潮湿雾气构成了影片的第一印象。",
      "在预告中，叶山小百合饰演的潜水调查员深津玲在打捞沉船残骸时发现一份被海水浸泡的名单。短短几个镜头里，她用克制的眼神传递出角色面对真相时的犹疑与坚定，被不少影迷评价为「近年来最有张力的表演片段」。",
      "导演佐藤健一在采访中表示，影片大量场景在真实的港口夜间拍摄，为的就是保留那种无法被布景复制的压抑感。叶山小百合为角色接受了近三个月的潜水训练，多数水下镜头均亲身上阵。",
      "据悉，《雾港夜航》还将作为本届亚洲电影节的开幕影片放映，完整片单将于下月公布。",
    ],
  },
  {
    id: 2,
    title: "《蓝色站台》正式杀青，叶山小百合挑战全新角色",
    date: "2024-10-29",
    category: "拍摄",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20image%20of%20an%20empty%20misty%20train%20platform%20under%20cold%20blue%20night%20light%20with%20a%20distant%20approaching%20train%2C%20cinematic%20photography%2C%20teal%20and%20amber%20tones%2C%20subtle%20film%20grain&width=800&height=500&seq=yh-news-02&orientation=landscape",
    summary: "悬疑新片《蓝色站台》宣布杀青，叶山小百合此次饰演列车调度员，与导演佐藤健一二度合作。",
    content: [
      "历经两个月的拍摄，悬疑电影《蓝色站台》近日正式杀青。这是导演佐藤健一与叶山小百合继《雾港夜航》之后的第二次合作，两人被媒体称为「最有默契的犯罪题材组合」。",
      "此次叶山小百合饰演的是一名深夜列车调度员沙罗。角色需要大量调度术语与专业操作，为此她提前进入铁路调度中心实地观摩，并学习了基础的时刻表推演。",
      "片方公布的杀青照中，叶山小百合身着深蓝色铁路制服站在空旷站台上，配文写着「最后一班列车，永远晚点三分钟」，引发影迷对剧情的诸多猜测。",
      "影片目前进入后期制作阶段，预计将于明年下半年与观众见面。",
    ],
  },
  {
    id: 3,
    title: "叶山小百合凭《樱色信笺》获最佳女主角提名",
    date: "2024-09-12",
    category: "奖项",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20image%20of%20a%20glamorous%20film%20awards%20ceremony%20red%20carpet%20with%20warm%20spotlights%20and%20elegant%20stage%2C%20amber%20and%20deep%20blue%20tones%2C%20editorial%20photography%2C%20subtle%20film%20grain&width=800&height=500&seq=yh-news-03&orientation=landscape",
    summary: "本届电影学院奖公布提名名单，叶山小百合凭借爱情电影《樱色信笺》入围最佳女主角。",
    content: [
      "本届电影学院奖今日公布提名名单，叶山小百合凭借在《樱色信笺》中饰演的图书管理员早川茜一角，入围最佳女主角。这是她个人第三次获得该奖项提名。",
      "评委会在提名理由中写道，叶山小百合「把一个安静的角色演出了丰富的层次，让沉默本身成为叙事的一部分」。影片中大量的写信与等待段落，几乎全靠她的细微表情支撑。",
      "收到提名消息时，叶山小百合正在新片片场。她通过经纪公司表示：「感谢每一位愿意读完那些信的观众，这个角色让我重新理解了表达的意义。」",
      "颁奖礼将于下月中旬举行，最终结果届时揭晓。",
    ],
  },
  {
    id: 4,
    title: "《东京回声》口碑持续走高，第二季确认制作",
    date: "2024-08-30",
    category: "剧集",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20image%20of%20a%20neon-lit%20tokyo%20street%20at%20night%20with%20glowing%20signs%20and%20blurred%20crowds%2C%20cyan%20and%20amber%20neon%20tones%2C%20cinematic%20photography%2C%20subtle%20film%20grain&width=800&height=500&seq=yh-news-04&orientation=landscape",
    summary: "悬疑剧《东京回声》播出后评分一路攀升，制作方正式宣布第二季立项，原班人马有望回归。",
    content: [
      "由叶山小百合主演的都市悬疑剧《东京回声》自播出以来热度不减，网络评分从开分一路上涨，成为本季度口碑最佳的剧集之一。",
      "剧中，叶山小百合饰演的调查记者三浦葵沿着一段深夜电台录音展开追查，剧集以声音为线索的独特设定被观众称为「最有沉浸感的悬疑剧」。",
      "制作方今日正式宣布第二季立项，编剧团队已开始新一季的剧本创作。官方透露，第二季将把视角从城市中心延伸到郊区，探讨「声音在更空旷的地方如何回响」。",
      "叶山小百合是否继续出演尚未最终确认，但她本人在社交平台上转发消息并留言「期待重逢」，被影迷视为回归的信号。",
    ],
  },
  {
    id: 5,
    title: "专访：叶山小百合谈表演、角色与生活",
    date: "2024-07-21",
    category: "专访",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20image%20of%20a%20young%20japanese%20woman%20seated%20in%20a%20quiet%20interview%20room%20with%20soft%20window%20light%20and%20a%20plant%2C%20warm%20minimal%20editorial%20photography%2C%20amber%20and%20muted%20blue%20tones%2C%20subtle%20grain&width=800&height=500&seq=yh-news-05&orientation=landscape",
    summary: "在一场长篇专访中，叶山小百合聊起自己挑选角色的标准，以及银幕之外的生活状态。",
    content: [
      "「我更在意一个角色有没有『没说出口的部分』。」谈到挑选剧本的标准时，叶山小百合这样回答。在她看来，表演的魅力不在于把情绪说满，而在于把留白交给观众。",
      "从《无声之刃》里沉默的女武士，到《白夜诊疗室》里冷静的医生，她塑造的角色往往内敛而坚韧。她说自己喜欢那些「不太会喊疼的人」，因为记录他们的方式必须更诚实。",
      "工作之外，叶山小百合保持着阅读与长距离散步的习惯。「走路的时候脑子特别清楚，很多角色的想法都是在路上想通的。」",
      "谈及未来，她表示希望能尝试更多喜剧题材，也想参与幕后的制作工作。「还有很多没做过的事，慢慢来就好。」",
    ],
  },
  {
    id: 6,
    title: "《白夜诊疗室》特别篇定档，原班人马回归",
    date: "2024-06-08",
    category: "剧集",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20image%20of%20a%20bright%20hospital%20corridor%20at%20night%20with%20soft%20lamplight%20and%20a%20lone%20walker%2C%20clean%20clinical%20lighting%20with%20amber%20accents%2C%20cinematic%20photography%2C%20subtle%20grain&width=800&height=500&seq=yh-news-06&orientation=landscape",
    summary: "医疗剧《白夜诊疗室》宣布推出两小时特别篇，叶山小百合饰演的江藤遥医生将再次回归。",
    content: [
      "曾收获良好口碑的医疗剧《白夜诊疗室》宣布推出两小时特别篇，原班人马悉数回归，叶山小百合将继续饰演外科医生江藤遥。",
      "特别篇的故事发生在正剧结局两年之后，白夜诊疗室面临被整合的命运，江藤遥必须在有限的资源下完成一场分秒必争的抢救。",
      "制片方表示，特别篇会延续剧集一贯的专业考据与人文关怀，「我们想做的是把那些在走廊里悄悄发生的温柔，再讲一次。」",
      "特别篇定于暑期档播出，具体日期将于近期公布。",
    ],
  },
  {
    id: 7,
    title: "叶山小百合出席亚洲电影节红毯",
    date: "2024-05-15",
    category: "活动",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20image%20of%20an%20elegant%20asian%20film%20festival%20red%20carpet%20at%20night%20with%20spotlights%20and%20crowds%20blurred%20in%20background%2C%20amber%20and%20deep%20blue%20tones%2C%20editorial%20photography%2C%20subtle%20grain&width=800&height=500&seq=yh-news-07&orientation=landscape",
    summary: "叶山小百合以一袭深色礼服亮相亚洲电影节红毯，并为开幕影片《雾港夜航》宣传造势。",
    content: [
      "亚洲电影节今晚开幕，叶山小百合以一袭深藏青色礼服亮相红毯，简洁的造型与含蓄的盘发成为当晚媒体镜头焦点。",
      "她此行主要为开幕影片《雾港夜航》宣传。谈到角色，她表示这次的挑战在于「把恐惧藏起来」，因为深津玲这个角色越是害怕，越要表现得镇定。",
      "红毯结束后，叶山小百合出席了影片的官方放映与观众交流环节，并回答了影迷关于水下拍摄的提问。",
      "影片在电影节的放映反响热烈，多家媒体给出了积极评价。",
    ],
  },
  {
    id: 8,
    title: "《黄昏图书馆》口碑出炉，被赞「最温柔的奇幻」",
    date: "2024-04-02",
    category: "剧集",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20image%20of%20a%20dusk-lit%20old%20library%20with%20towering%20bookshelves%20and%20golden%20light%20through%20tall%20windows%2C%20amber%20and%20deep%20blue%20tones%2C%20cinematic%20photography%2C%20subtle%20grain&width=800&height=500&seq=yh-news-08&orientation=landscape",
    summary: "奇幻温情剧《黄昏图书馆》播出后口碑出炉，观众与媒体均给出高度评价。",
    content: [
      "由叶山小百合主演的奇幻温情剧《黄昏图书馆》播出过半，口碑稳步走高，被观众称为「这个春天最温柔的剧」。",
      "剧中，图书馆只在黄昏开放，每一本书都记录着陌生人的心愿。叶山小百合饰演的馆主森野栞安静而神秘，成为串联各个单元故事的核心。",
      "有评论指出，剧集难得地没有把奇幻当成噱头，而是用它去承载更朴素的情感——「它讲的不是魔法，而是有人愿意认真听完你的故事」。",
      "剧集目前更新至第六集，最终回将于下周播出。",
    ],
  },
  {
    id: 9,
    title: "叶山小百合新作造型首度曝光",
    date: "2024-03-11",
    category: "资讯",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20image%20of%20a%20film%20costume%20fitting%20room%20with%20vintage%20clothes%20rack%20and%20warm%20lamp%20light%2C%20muted%20amber%20and%20blue%20tones%2C%20editorial%20photography%2C%20subtle%20film%20grain&width=800&height=500&seq=yh-news-09&orientation=landscape",
    summary: "叶山小百合为新片试装的照片曝光，全新造型一改以往风格，引发影迷热议。",
    content: [
      "叶山小百合正在为新片进行试装，一组幕后照片于今日曝光。照片中她尝试了与以往截然不同的造型，风格清爽利落。",
      "据剧组工作人员透露，这次的服装设计参考了大量真实资料，力求在细节上贴近角色的生活背景。造型团队为此准备了近三十套备选方案。",
      "照片发布后迅速登上社交平台话题榜，不少影迷表示「完全认不出来，但很好看」，也有人猜测新角色与以往反差极大。",
      "影片的更多信息将在定档发布会上公布。",
    ],
  },
  {
    id: 10,
    title: "幕后花絮：《霓虹尽头的信》是怎样拍成的",
    date: "2024-02-20",
    category: "幕后",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20image%20of%20a%20futuristic%20film%20set%20with%20glowing%20blue%20screens%20and%20amber%20accent%20lights%20at%20night%2C%20cinematic%20production%20photography%2C%20subtle%20film%20grain&width=800&height=500&seq=yh-news-10&orientation=landscape",
    summary: "科幻爱情片《霓虹尽头的信》释出幕后特辑，揭秘信号塔场景与电波特效的制作过程。",
    content: [
      "科幻爱情片《霓虹尽头的信》今日发布幕后特辑，首次展示影片中标志性的海边信号塔场景是如何搭建的。",
      "美术团队透露，信号塔的主体结构在摄影棚内搭建，外部海景则通过实景与后期合成完成。为了呈现「电波穿过夜空」的效果，特效组制作了超过三百个独立图层。",
      "叶山小百合在特辑中分享，拍摄控制室戏份时，她需要对着大量虚拟屏幕表演，「最难的是让眼神相信那些光是真的。」",
      "影片的完整幕后纪录片将于下月上线流媒体平台。",
    ],
  },
];